import 'rc-calendar/assets/index.css';
import React, { useState } from 'react';
import RangeCalendar from 'rc-calendar/lib/RangeCalendar';
import DatePicker from 'rc-calendar/lib/Picker';

import zhCN from 'rc-calendar/lib/locale/zh_CN';
import enUS from 'rc-calendar/lib/locale/en_US';

import moment from 'moment';
import 'moment/locale/zh-cn';
import 'moment/locale/en-gb';
import './DateRangePicker.scss';

const format = 'YYYY-MM-DD';
const fullFormat = 'DD/MM/YYYY';
const cn = location.search.indexOf('cn') !== -1;

const now = moment();
if (cn) {
  now.locale('zh-cn').utcOffset(8);
} else {
  now.locale('en-gb').utcOffset(0);
}

const DateRangePicker = ({
  startValue,
  endValue,
  onStartChange,
  onEndChange,
  disabledStartDate,
  disabledDate,
  startOpen,
  endOpen,
  onStartOpenChange,
  onEndOpenChange
}) => {
  const [hoverValue, setHoverValue] = useState([]);

  const onHoverChange = (hoverValue) => {
    setHoverValue(hoverValue);
  };

  const open = Boolean(startOpen || endOpen);

  const onOpenChange = (nextOpen) => {
    // keep parent state consistent, regardless of which side opened it
    onStartOpenChange?.(nextOpen);
    onEndOpenChange?.(nextOpen);
  };

  const clearRange = (e) => {
    e?.preventDefault?.();
    e?.stopPropagation?.();
    onStartChange?.([null, null]);
    onOpenChange(false);
  };

  const onRangeChange = (value) => {
    // rc-calendar returns [start, end]
    if (!Array.isArray(value)) return;
    let start = value[0] || null;
    let end = value[1] || null;

    if (start && end && end.isBefore(start, 'day')) {
      const temp = start;
      start = end;
      end = temp;
    }

    onStartChange?.([start, end]);
    if (end) {
      onEndChange?.([start, end]);
    }
  };

  const renderPicker = () => {
    const isDateDisabled = (current) => {
      if (disabledDate?.(current)) return true;
      if (disabledStartDate?.(current)) return true;
      return false;
    };

    const calendar = (
      <RangeCalendar
        hoverValue={hoverValue}
        onHoverChange={onHoverChange}
        type="both"
        locale={cn ? zhCN : enUS}
        defaultValue={now}
        format={format}
        onChange={onRangeChange}
        disabledDate={isDateDisabled}
        className="hrx-date-range__calendar"
      />
    );

    return (
      <DatePicker
        open={open}
        onOpenChange={onOpenChange}
        calendar={calendar}
        value={[startValue, endValue]}
      >
        {() => (
          <span className="hrx-date-range__field">
            <input
              readOnly
              placeholder="Select date range"
              value={
                startValue && endValue
                  ? `${startValue.format(fullFormat)} - ${endValue.format(fullFormat)}`
                  : startValue
                    ? `${startValue.format(fullFormat)} - `
                    : ''
              }
              className="hrx-date-range__input"
            />
            {startValue && (
              <button
                type="button"
                aria-label="Clear date range"
                className="hrx-date-range__clear"
                onClick={clearRange}
              >
                ×
              </button>
            )}
            <i className="icofont-calendar hrx-date-range__icon" />
          </span>
        )}
      </DatePicker>
    );
  };

  return <div className="hrx-date-range">{renderPicker()}</div>;
};

export default DateRangePicker;
